<template>
  <div
    v-loading.fullscreen="loading"
    element-loading-text
    element-loading-spinner="el-icon-loading"
    class="moow-master-container"
  >
    <header-alt :overlay="true"></header-alt>
    <b-container fluid class="filter-container-hero">
      <div class="container vert-cent-high-screens">
        <b-row>
          <b-col lg="5" md="6" sm="10" style="text-align:center">
            <b-collapse visible id="filterform">
              <md-card md-with-hover class="island-card mt-5">
                <!-- <md-ripple> -->
                <md-card-header>
                  <div class="moow-hero-title mt-5">
                    {{i18n_local.say_hello}}<br>
                    {{i18n_local.your_new_home}}
                  </div>
                </md-card-header>

                <md-card-content>
                  <md-autocomplete
                    v-model="selectedPlace"
                    md-layout="box"
                    :md-options="placesPredictions"
                    @md-changed="getPlacePredictions"
                    @md-selected="getMunicipality"
                  >
                    <label>City or Parish</label>

                    <template
                      slot="md-autocomplete-item"
                      slot-scope="{ item }"
                    >{{ item.description }}</template>
                  </md-autocomplete>

                  <p style="text-align:left; margin-bottom: 0" class="moow-info-txt large mt-3">Price</p>
                  <b-row class="mo-card-input-row">
                    <b-col sm="4" class="mo-card-input-col">
                      <md-field>
                        <label>Starting</label>
                        <md-input v-model="filterPriceFrom" type="number" placeholder="from"></md-input>
                      </md-field>
                    </b-col>
                    <b-col sm="4" class="mo-card-input-col">
                      <md-field>
                        <label>Up</label>
                        <md-input v-model="filterPriceTo" type="number"  placeholder="to"></md-input>
                      </md-field>
                    </b-col>
                    <b-col sm="4" class="mo-card-input-col">
                      <md-field>
                        <label for="per">Price per</label>
                        <md-select v-model="filterPriceBy" name="per" id="per">
                          <md-option value="monthly">month</md-option>
                          <md-option value="daily">day</md-option>
                        </md-select>
                      </md-field>
                    </b-col>
                  </b-row>

                  <p style="text-align:left; margin-bottom: 0" class="moow-info-txt large mt-3">Bedrooms</p>
                  <b-row class="mo-card-input-row">
                    <b-col sm="4" class="mo-card-input-col">
                      <md-field>
                        <label>Bedrooms</label>
                        <md-input v-model="filterBedroomsMin" type="number" placeholder="min"></md-input>
                      </md-field>
                    </b-col>
                    <b-col sm="4" class="mo-card-input-col">
                      <md-field>
                        <label>Bedrooms</label>
                        <md-input v-model="filterBedroomsMax" type="number"  placeholder="min"></md-input>
                      </md-field>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <moow-button
                      :type="['light', 'wide']"
                      :camel="true"
                      :btnText="i18n_local.find_home"
                      class="ml-3"
                      v-scroll-to="'#search-results'"
                      @mClick="filterListings()"
                    />
                  </b-row>
                  <b-row class="mt-2">
                    <moow-button
                      :type="['dark', 'wide', 'outlined' ,'flat']"
                      :camel="true"
                      :btnText="i18n_local.free_valuation"
                      class="ml-3"
                      @mClick="leavePage('market', 'valuation')"
                    />
                  </b-row>
                </md-card-content>
              </md-card>
            </b-collapse>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <!--  SEARCH RESULTS -->
    <b-container id="search-results">
      <!-- <div class="container" id="results"> -->
        <md-toolbar class="mt-3 md-dense" style="background-color:white" md-elevation="2">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <md-field md-clearable>
                  <label>Search address, price, desc...</label>
                  <md-input v-model="searchInput"></md-input>
              </md-field>
            </div>
            <div class="md-toolbar-section-end">
              <md-field class="sort-menu">
                <label for="movie">Sort by</label>
                <md-select
                  v-model="selectedSort"
                  name="sort"
                  id="sort"
                  @md-selected="startSortListings"
                >
                  <md-option value="none">None</md-option>
                  <md-option value="price-hf">Price: Highest first</md-option>
                  <md-option value="price-lf">Price: Lowest first</md-option>
                  <md-option value="date-hf">Date: Latest first</md-option>
                  <md-option value="date-lf">Date: Oldest first</md-option>
                  <md-option value="rooms-hf">Bedrooms: Highest first</md-option>
                  <md-option value="rooms-lf">Bedrooms: Lowest first</md-option>
                </md-select>
              </md-field>

              <md-button @click="switchToListView" class="mo-btn-list md-small-hide">
                <md-icon>list</md-icon>
              </md-button>
              <md-button @click="switchToGridView" class="mo-btn-grid md-small-hide">
                <md-icon>grid_on</md-icon>
              </md-button>
            </div>
          </div>
          <div v-if="showFilterTags" class="md-toolbar-row">
            <md-button @click="clearFilterAndSearch" class="mo-text-blue">Clear filter</md-button>
            <!-- TODO: show implemented filters here -->
            <md-chip v-for="filter in filterTagsArr" :key="filter">{{filter}}</md-chip>
          </div>
        </md-toolbar>
        <b-row class="mt-2">
          <div v-if="loadingListings" class="loader-rolling-local mt-5" style="margin: 0 auto;"></div>
          <b-col v-else class="">
            <div v-for="(data,id) in manuallyFilteredListings" :key="data.id" style="display:contents">
              <!-- *** LIST *** -->

              <b-row
                v-if="inListView"
                lg="9"
                md="10"
                sm="12"
                class="marketplace-element-container-clickable mt-3"
              >
                <b-col lg="3" md="4" sm="6" class="dash-element-image hover-listener" @click="showImagePreview(data)">
                  <clazy-load :src="getListingCoverThumbnail(data)" style="overflow: hidden;height: 100%;">
                    <!-- The image slot renders after the image loads. -->
                    <b-img fluid rounded :id="id" :src="getListingCoverThumbnail(data)" alt="Thumbnail" class="listing-img-list  cast-shadow zoom-on-hover"/>
                    <!-- The placeholder slot displays while the image is loading. -->
                    <div slot="placeholder">
                      <!-- You can put any component you want in here. -->
                      <b-img fluid rounded :src="placeholder" alt="Loading" />
                    </div>
                  </clazy-load>
                </b-col>
                <b-col lg="8" md="8" sm="8" @click="navigateToListings($event, data.maaklerID)">
                  <b-row>
                    <b-col>
                      <b-row>
                        <span class="mo-card-title">{{data.marketingDet.shortDesc}}</span>
                      </b-row>
                      <b-row class="mt-3">
                        <p
                          class="dash-item-subtitle"
                        >{{data.location.address.municipality}}, {{data.location.address.street}} {{data.location.address.number}}</p>
                      </b-row>
                      <b-row>
                        <md-list>
                          <md-list-item>
                            <md-icon>hotel</md-icon>
                            <div class="md-list-item-text">
                              <span>{{data.techDet.nrOfBedrooms}}</span>
                            </div>
                          </md-list-item>
                        </md-list>
                      </b-row>
                      <b-row>
                        <div
                          class="mo-card-title"
                          style="margin-right:5px;"
                          v-if="getDiscountedPrices(data).monthlyStartingFrom && getDiscountedPrices(data).dailyStartingFrom"
                        >
                          <span class="monthly-price price-text">{{getDiscountedPrices(data).monthlyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="monthly-price price-text" style="color:grey;font-size:16px"> / month</span>
                          <span class="daily-price price-text">{{getDiscountedPrices(data).dailyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="daily-price price-text" style="color:grey;font-size:16px"> / day</span>
                        
                        </div>
                        <span class="mo-card-title price-text" v-else-if="getDiscountedPrices(data).monthlyStartingFrom" ><span>{{getDiscountedPrices(data).monthlyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="price-text" style="color:grey;font-size:16px"> / month</span></span>
                        <span class="mo-card-title price-text" v-else><span>{{getDiscountedPrices(data).dailyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="price-text" style="color:grey;font-size:16px"> / day</span></span>
                      
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!-- ***  GRID *** -->
              <md-card v-else class="mo-listing-card">
                <md-card-area class="bottom-div-holder">
                  <md-card-media class="hover-listener" >
                    <clazy-load :src="getListingCoverThumbnail(data)" class="grid-listing-img-container">
                      <!-- The image slot renders after the image loads. -->
                      <img :id="id" :src="getListingCoverImage(data)" class="zoom-on-hover" @click="showImagePreview(data)"/>
                      <!-- The placeholder slot displays while the image is loading. -->
                      <div slot="placeholder">
                        <!-- You can put any component you want in here. -->
                        <img :id="id" :src="placeholder" alt="Thumbnail" />
                      </div>
                    </clazy-load>
                  </md-card-media>

                  <md-card-header>
                    <div class="md-title">{{data.marketingDet.shortDesc}}</div>
                    <div
                      class="md-subhead mt-3" style="font-weight: bold"
                    >{{data.location.address.municipality}}, {{data.location.address.street}} {{data.location.address.number}}</div>
                  </md-card-header>

                  <md-card-content class="bottom-div" style="width:100%;">
                    <b-row>
                      <b-col>
                        <md-list>
                          <md-list-item>
                            <md-icon>hotel</md-icon>
                            <div class="md-list-item-text">
                              <span>{{data.techDet.nrOfBedrooms}}</span>
                            </div>
                          </md-list-item>
                        </md-list>
                      </b-col>
                      <b-col>
                        <div
                          class="mo-card-title"
                          v-if="getDiscountedPrices(data).monthlyStartingFrom && getDiscountedPrices(data).dailyStartingFrom"
                        >
                          <span
                            class="monthly-price"
                          >{{getDiscountedPrices(data).monthlyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="monthly-price"  style="color:grey;font-size:16px; font-weight: bold">/month</span>
                          <span
                            class="daily-price"
                          >{{getDiscountedPrices(data).dailyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span class="daily-price"  style="color:grey;font-size:16px; font-weight: bold">/day</span>
                        </div>
                        <!-- Case : if listing only have monthly price -->
                        <div
                          class="mo-card-title"
                          style="text-align:left;"
                          v-else-if="getDiscountedPrices(data).monthlyStartingFrom"
                        >
                        <span class="mo-card-title" ><span>{{getDiscountedPrices(data).monthlyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span style="color:grey;font-size:16px; font-weight: bold"> / month</span></span>
                                              </div>
                        <!-- Case : if listing only have daily price -->
                        <div class="mo-card-title" style="text-align:right;" v-else>
                          <span class="mo-card-title"><span>{{getDiscountedPrices(data).dailyStartingFrom}}{{getCurrencySign(data.txnDet.currency)}}</span><span style="color:grey;font-size:16px; font-weight: bold"> / day</span></span>
                        </div>
                      </b-col> 
                    </b-row>
                     <moow-button
                        :type="['light', 'wide']"
                        :camel="true"
                        :btnText="i18n_local.look"
                        @mClick="navigateToListings($event, data.maaklerID)"
                      />
                  </md-card-content>
                </md-card-area>
              </md-card>
            </div>
            <b-row style="padding:2em">
              <div
                v-if="loadingAdditionalListings"
                class="loader-rolling-local"
                style="margin:0 auto"
              ></div>
              <span v-else-if="moreListingsAvailable" style="margin:0 auto;color:lightsteelblue">No more listings</span>
            </b-row>
          </b-col>
        </b-row>
      <!-- </div> -->
    </b-container>
    <md-dialog :md-active.sync="showImgPreview" class="preview-container" id="preview-img-holder" style="height: 90vh;width:90vw">
      <img-gallery-min  class="toggleable-gallery"
        :images="previewListingImages"
        :selectImageFunction="selectImage">
      </img-gallery-min>
      <div class="btn-fullscreen prev show" v-on:click="previousPreviewImg()"></div>
      <div class="btn-fullscreen next show" v-on:click="nextPreviewImg()"></div>
      <moow-button
        :type="['light', 'wide']"
        :camel="true"
        :btnText="i18n_local.look"
        @mClick="navigateToListings($event, data.maaklerID)"
      />
      <!-- <md-button class="md-fab md-primary" style="position:absolute;bottom:0" @click="navigateToListingsDirect()"><md-icon>open_in_new</md-icon></md-button> -->
    </md-dialog>
  </div>
</template>

<script>
import {
  getMaaklerListingsLiteOlderThen,
  getListingCoverThumbnail,
  getListingCoverImage
} from "../listingsRepository.js";
import { checkForLoginOrGoAnonymous } from "../users/repositories/userRepository.js";
import { getPlacePredictions } from "../mapsRepository.js";
import {
  getDefaultStartingFromPrices
} from "../pricing/pricingCalculator.js";
import { filterMarketplaceListingsBasedOn } from "../searchFunctions.js";
import ImageGallery from '../components/listingComponents/imgQuickGallery.vue'
import { mapGetters } from "vuex";

export default {
  name: "listingsearch",
  components: {
      'img-gallery-min': ImageGallery,
  },
  validator: null,
  data() {
    return {
      previewListingImages: [],
      previewImageUrl: "",
      showImgPreview:false,
      searchInput: "",
      filterPriceBy: "",
      displayPriceTier: "monthly",
      noListings: false,
      showAddressSeachOnHeader: false,
      loading: false,
      placesPredictions: [],
      selectedPlace: "",
      filterMuni: undefined,
      filterPriceFrom: undefined,
      filterPriceTo: undefined,
      filterBedroomsMin: undefined,
      filterBedroomsMax: undefined,
      loadingListings: false,
      filteredListings: [],
      sortedListings: [],
      loggedInAs: false,
      userIsAnonymous: true,
      currentUser: undefined,
      loadingAdditionalListings: false,
      inListView: false,
      showFilterForm: true,
      selectedSort: "",
      sortListings: false,
      moreListingsAvailable: true,
      filterTags: [],
      showFilterTags: false,
      somethingIsBroken: false,
      selectedImageIdx: 0,
      filterTagsArr: [],
      previewListingId: ""
    };
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    filterButtonText(){
      return this.i18n_local.find_home
    },
    manuallyFilteredListings(){
      if(!this.searchInput) return this.sortedListings
        else{
          return filterMarketplaceListingsBasedOn(this.sortedListings, this.searchInput)
      }
    },
    placeholder() {
      return require("../assets/placeholder.png");
    },
    noListingsIcon() {
      return require("../assets/404_listing.svg");
    },
    noListingsFound() {
      return this.sortedListings.length <= 0;
    },
    listingArray() {
      return this.sortedListings.length;
    }
  },
  created() {
    if (this.$route.query.autoq === "true") {
      var muni = this.$route.query.muni;
      if (muni === "Any") muni = "";
      var filter = {
        muni: muni,
        priceFrom: this.$route.query.priceFrom,
        priceTo: this.$route.query.priceTo,
        bedroomsFrom: this.$route.query.bedroomsFrom,
        bedroomsTo: this.$route.query.bedroomsTo
      };
      this.populateFilterForm(filter);
      this.filterListings();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getAdditionalListingsGate();
    checkForLoginOrGoAnonymous()
      .then(user => {
        this.currentUser = user;
        this.loggedInAs = true;
        this.userIsAnonymous = user.isAnonymous;
        // this.getInitialDefaultListings();
      })
      .catch(err => {
        this.somethingIsBroken = true;
      });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    previousPreviewImg(){
      if(this.selectedImageIdx > 0) this.selectedImageIdx = this.selectedImageIdx - 1
      else this.selectedImageIdx = this.previewListingImages.length-1
      this.setImgInPreview(this.previewListingImages[this.selectedImageIdx].url)
    },
    nextPreviewImg(){
      if(this.selectedImageIdx < this.previewListingImages.length-1) this.selectedImageIdx = this.selectedImageIdx + 1
      else this.selectedImageIdx = 0
      this.setImgInPreview(this.previewListingImages[this.selectedImageIdx].url)
    },
    selectImage(imageId){
      this.selectedImageIdx = imageId
      this.setImgInPreview(this.previewListingImages[imageId].url)
    },
    showImagePreview(listing){
      this.previewListingId = listing.maaklerID
      if(listing.marketingDet.images){
        this.previewListingImages=listing.marketingDet.images
        this.showImgPreview = true
        var self = this
        setTimeout(function () {
          self.setImgInPreview(getListingCoverImage(listing))
        }, 500);
        this.selectedImageIdx = 0
      }
    },
    setImgInPreview(url){
      document.getElementById("preview-img-holder").style.background = "url(" + url + ") no-repeat center center"
      document.getElementById("preview-img-holder").style.backgroundSize = "contain"
    },
    handleScroll(event) {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        if (
          this.moreListingsAvailable &&
          !this.loadingListings &&
          !this.loadingAdditionalListings
        ) {
          this.getAdditionalListingsGate();
        }
      }
    },
    populateFilterForm(filter) {
      this.selectedPlace = filter.muni;
      this.filterMuni = filter.muni;
      this.filterPriceFrom = filter.priceFrom;
      this.filterPriceTo = filter.priceTo;
      this.filterBedroomsMin = filter.bedroomsFrom;
      this.filterBedroomsMax = filter.bedroomsTo;
    },
    getListingCoverThumbnail(listing) {
      return getListingCoverThumbnail(listing);
    },
    getListingCoverImage(listing) {
      var comverImg = getListingCoverImage(listing);
      return comverImg;
    },
    getCurrencySign(currency) {
      if (currency == "eur") return "€";
      else if (currency == "usd") return "$";
      else return "";
    },
    getTxnDisplayType(txnType) {
      if (txnType == "sale") return "sale";
      else return "rent";
    },
    getTxnPeriodType(txnType) {
      if (txnType == "rent") return "/ month";
      else if (txnType == "rentShortTerm") return "/ night";
    },
    getPlacePredictions(searchTerm) {
      try {
        let searhTermForUrl = searchTerm.replace(new RegExp(" ", "g"), "+");
        this.placesPredictions = getPlacePredictions(
          searhTermForUrl,
          "(cities)"
        )
          .then(predictions => {
            return predictions;
          })
          .catch(err => {
            return [];
          });
      } catch (error) {}
    },
    getMunicipality(googPrediction) {
      this.selectedPlace = googPrediction.description;
      this.placeId = googPrediction.place_id;
      try {
        this.filterMuni = googPrediction.structured_formatting.main_text;
      } catch (err) {
        this.filterMuni = "";
      }
    },
    getInitialDefaultListings() {
      this.loadingListings = true;
      let howManyListingsByDefault = 10;
      var currentUnix = new Date().getTime();
      let filter = this.createFilterFromUserSelection();
      getMaaklerListingsLiteOlderThen(
        currentUnix,
        howManyListingsByDefault,
        filter
      )
        .then(listings => {
          this.filteredListings = listings;
          this.sortedListings = listings;
          // create unique set of listings
          this.filteredListings = Array.from(
            new Set(this.filteredListings.map(a => a._id))
          ).map(id => {
            return this.filteredListings.find(a => a._id === id);
          });
          this.sortedListings = Array.from(
            new Set(this.sortedListings.map(a => a._id))
          ).map(id => {
            return this.sortedListings.find(a => a._id === id);
          });
          //
          this.loadingListings = false;
        })
        .catch(err => {
          this.filteredListings = [];
          this.loadingListings = false;
        });
    },
    getAdditionalListingsGate() {
      var lastListingUnix = new Date().getTime();
      let howManyAdditional = 10;

      if (this.filteredListings.length > 0) {
        var lastListing = this.filteredListings[
          this.filteredListings.length - 1
        ];
        lastListingUnix =
          Date.parse(lastListing.creationDet.createdDate) / 1000;
      }
      this.getAdditionalListings(lastListingUnix, howManyAdditional);
    },
    getAdditionalListings(olderThanUnix, howMany) {
      this.loadingAdditionalListings = true;
      let filter = this.createFilterFromUserSelection();
      getMaaklerListingsLiteOlderThen(olderThanUnix, howMany, filter)
        .then(listings => {
          if (listings.length > 0) {
            this.filteredListings = this.filteredListings.concat(listings);
            this.sortedListings = this.sortedListings.concat(listings);
            // create unique filteredListings and sortedListings
            this.filteredListings = Array.from(
              new Set(this.filteredListings.map(a => a._id))
            ).map(id => {
              return this.filteredListings.find(a => a._id === id);
            });
            this.sortedListings = Array.from(
              new Set(this.sortedListings.map(a => a._id))
            ).map(id => {
              return this.sortedListings.find(a => a._id === id);
            });
            //
            if (this.sortListings) this.startSortListings();
          } else {
            this.moreListingsAvailable = false;
          }
          this.loadingAdditionalListings = false;
        })
        .catch(err => {
          this.loadingAdditionalListings = false;
        });
    },
    clearFilterAndSearch() {
      this.selectedPlace = undefined;
      this.filterMuni = undefined;
      this.filterPriceFrom = undefined;
      this.filterPriceTo = undefined;
      this.filterBedroomsMin = undefined;
      this.filterBedroomsMax = undefined;
      this.clearFilterTags();
      this.getInitialDefaultListings();
    },
    setFilterTags(filter) {
      // this.filterTags = []
      // for (var key in filter) {
      //   this.filterTags.push({key:filter[key]});
      // }
      this.filterTags = filter;
      if (this.filterTags) {
        this.showFilterTags = true;
      } else {
        this.showFilterTags = false;
      }
    },
    clearFilterTags() {
      this.filterTags = [];
      this.filterTagsArr = [];
      this.showFilterTags = false;
    },
    filterListings() {
      if(!this.filterHasInput()) return;
      this.filterTagsArr = [];
      this.displayPriceTier = this.getPriceTierBasedOnFilterPriceSizes(
        this.filterPriceFrom,
        this.filterPriceTo
      );
      this.loadingListings = true;
      if (this.currentUser) {
        let f = this.createFilterFromUserSelection();
        let t = new Date().getTime();
        this.setFilterTags(f);
        this.createFilterArray();
        getMaaklerListingsLiteOlderThen(t, 20, f)
          .then(listings => {
            this.filteredListings = listings;
            this.sortedListings = listings;
            if (listings.length > 0 && this.sortListings)
              this.startSortListings();
            else this.moreListingsAvailable = false;
            this.loadingListings = false;
            this.showClearBtn = true;
          })
          .catch(err => {
            this.loadingListings = false;
          });
      } else {
        this.loadingListings = false;
      }
      this.moreListingsAvailable = true;
    },
    filterHasInput(){
      return (this.filterBedroomsMin || this.filterBedroomsMax || this.filterPriceBy || this.filterPriceTo || this.filterPriceFrom || this.selectedPlace)
    },
    // getPriceTierBasedOnFilterPriceSizes(priceFrom, priceTo) {
    //   if (priceFrom > 150 || priceTo > 200) return "monthly";
    //   else return "daily";
    // },
    getPriceTierBasedOnFilterPriceSizes(filterPriceBy) {
      return filterPriceBy;
    },
    startSortListings() {
      this.sortListings = true;
      switch (this.selectedSort) {
        case "none":
          this.sortListings = false;
          this.sortedListings = this.filteredListings;
          break;
        case "price-hf":
          this.sortedListings.sort((listing1, listing2) => {
            if (listing1.txnDet.priceMonthly && listing2.txnDet.priceMonthly) {
              return (
                this.getDiscountedPrices(listing2).monthlyStartingFrom -
                this.getDiscountedPrices(listing1).monthlyStartingFrom
              );
            } else {
              return 1;
            }
          });
          break;
        case "price-lf":
          this.sortedListings.sort((listing1, listing2) => {
            if (listing1.txnDet.priceMonthly && listing2.txnDet.priceMonthly) {
              return (
                this.getDiscountedPrices(listing1).monthlyStartingFrom -
                this.getDiscountedPrices(listing2).monthlyStartingFrom
              );
            } else {
              return 1;
            }
          });
          break;
        case "rooms-hf":
          this.sortedListings.sort((listing1, listing2) => {
            return (
              listing1.techDet.nrOfBedrooms < listing2.techDet.nrOfBedrooms
            );
          });
          break;
        case "rooms-lf":
          this.sortedListings.sort((listing1, listing2) => {
            return (
              listing1.techDet.nrOfBedrooms > listing2.techDet.nrOfBedrooms
            );
          });
          break;
        case "date-hf":
          this.sortedListings.sort((listing1, listing2) => {
            return (
              listing1.creationDet.createdDate <
              listing2.creationDet.createdDate
            );
          });
          break;
        case "date-lf":
          this.sortedListings.sort((listing1, listing2) => {
            return (
              listing1.creationDet.createdDate >
              listing2.creationDet.createdDate
            );
          });
          break;
        default:
      }
    },
    createFilterFromUserSelection() {
      if (this.filterPriceBy === "monthly") {
        return {
          municipality: this.filterMuni,
          priceDailyFromInc: 1,
          priceDailyToInc: 1,
          priceMonthlyFromInc: this.filterPriceFrom,
          priceMonthlyToInc: this.filterPriceTo,
          bedroomsMinInc: this.filterBedroomsMin,
          bedroomsMaxInc: this.filterBedroomsMax,
          termType: "monthly"
        };
      } else if (this.filterPriceBy === "daily") {
        return {
          municipality: this.filterMuni,
          priceDailyFromInc: this.filterPriceFrom,
          priceDailyToInc: this.filterPriceTo,
          priceMonthlyFromInc: 1,
          priceMonthlyToInc: 1,
          bedroomsMinInc: this.filterBedroomsMin,
          bedroomsMaxInc: this.filterBedroomsMax,
          termType: "daily"
        };
      } else {
        return {
          municipality: this.filterMuni,
          priceDailyFromInc: this.filterPriceFrom,
          priceDailyToInc: this.filterPriceTo,
          priceMonthlyFromInc: this.filterPriceFrom,
          priceMonthlyToInc: this.filterPriceTo,
          bedroomsMinInc: this.filterBedroomsMin,
          bedroomsMaxInc: this.filterBedroomsMax
        };
      }
    },
    createFilterArray() {
      if (this.filterMuni) {
        this.filterTagsArr.push("Municipality : " + this.filterMuni);
      }
      if (this.filterPriceFrom) {
        this.filterTagsArr.push("Price From : " + this.filterPriceFrom);
      }
      if (this.filterPriceTo) {
        this.filterTagsArr.push("Price To : " + this.filterPriceTo);
      }
      if (this.filterBedroomsMin) {
        this.filterTagsArr.push("Min. Bedrooms : " + this.filterBedroomsMin);
      }
      if (this.filterBedroomsMax) {
        this.filterTagsArr.push("Max. Bedrooms : " + this.filterBedroomsMax);
      }
    },
    toggleFilterForm() {
      if (this.showFilterForm) this.showFilterForm = false;
      else this.showFilterForm = true;
    },
    switchToListView() {
      this.inListView = true;
    },
    switchToGridView() {
      this.inListView = false;
    },
    navigateToListingsDirect(){
      this.previewListingId?window.open("/#/listing/" + this.previewListingId, "_blank"):void 0;  // open in new windoe
    },
    navigateToListings(event, listingsId) {
      window.open("/#/listing/" + listingsId, "_blank");  // open in new windoe
      // this.$router.push({
      //   name: 'listing',
      //   params: {
      //     listingId: listingsId
      //   }
      // })
    },
    leavePage(from, to) {
      this.$store.dispatch("visitPage", from);
      this.$router.push({
        name: to
      });
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    getBaseRents: function(txnDet) {
      return {
        rentDaily: txnDet.priceDaily,
        rentMonthly: txnDet.priceMonthly
      };
    },
    getDiscount: function(txnDet) {
      return {
        weeklyDiscount: txnDet.weeklyDiscount,
        mediumPeriodDiscount: txnDet.mediumPeriodDiscount,
        longPeriodDiscount: txnDet.longPeriodDiscount
      };
    },
    getDiscountedPrices: function(item) {
      return getDefaultStartingFromPrices(
        this.getBaseRents(item.txnDet),
        this.getDiscount(item.txnDet)
      );
    }
  }
};
</script>

<style scoped>
@import "../assets/styles/global.css";
@import "../assets/styles/listings-view.css";
@import "../assets/styles/portal.css";

.marketplace-element-container-clickable{
  background-color: white;
  border-radius: 10px;
  width: 100%;
  margin: 0 auto;
}

.no-listings-found {
  height: 200px;
  width: 200px;
  text-align: center;
}

.md-chip {
  background-color: rgba(74, 74, 253, 0.37);
  color: white;
  font-weight: bold;
}
.md-autocomplete {
  background-color: white;
  opacity: 1;
}

.md-menu-content.md-select-menu {
  background-color: white !important;
}
.md-menu-content.md-autocomplete-box-content {
  background-color: white !important;
}

.mo-listing-card {
  margin: 12px;
  display: inline-block;
  vertical-align: top;
  width: 30.5%;
  padding: 1em;
  height: 520px;

  /* light background */

background: #FFFFFF;
border: 1px solid #DEDEDE;
box-sizing: border-box;
/* Strong Shadow */

box-shadow: 0px 13px 19px rgba(0, 0, 0, 0.07);
border-radius: 16px;
}

.sort-menu {
  max-width: 300px;
}


/*  from infinity to max 1200 and then this kicks in*/
@media (min-width: 700px) {
  .hero-campaign-cta{
    position: absolute;
    bottom: 0;
    margin: 0 auto;
    right: 0;
  }
}


/*  from infinity to max 700 and then this kicks in*/
@media (max-width: 1000px) {

  .mo-listing-card {
    width: 95%;
  }

  #result-title {
    display: none;
  }

  .sort-menu {
    max-width: 100px;
  }
}

.price-text{
  font-weight: bold;

}

.marketplace-element-container-clickable .daily-price {
  display: none;
}
.marketplace-element-container-clickable:hover .daily-price {
  display: inline;
}
.marketplace-element-container-clickable:hover .monthly-price {
  display: none;
}

.mo-listing-card .daily-price {
  display: none;
}
.mo-listing-card:hover .daily-price {
  display: inline;

}
.mo-listing-card:hover .monthly-price {
  display: none;
}

.grid-listing-img-container{
  overflow:hidden;
  height: 100%;
  min-height: 212.38px;
  max-height: 215px;
  border-radius: 16px;
}

.grid-listing-img-container img{
  min-height: 212.38px;

}


</style>


// WEBPACK FOOTER //
// src/components/ListingSearch.vue